var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "237px",
    height: "41px",
    viewBox: "0 0 237 41",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8627411,5.6 L20.9137074,14.6509663 L18.6509658,16.9137078 L11.656,9.919 L4.66274156,16.9137078 L2.4,14.6509663 L11.4509663,5.6 L11.656,5.806 L11.8627411,5.6 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 18.2951981,
    cy: 18.2951981,
    r: 18.2951981
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-element/Header",
    transform: "translate(-20.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bot",
    transform: "translate(22.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "IDEA---HR-services-Copy",
    fontFamily: "SourceSansPro-SemiBold, Sou rce Sans Pro",
    fontSize: 18,
    fontWeight: 600,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 49,
    y: 26
  }, "AXABots Agent")), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#000000",
    strokeWidth: 1.79999995,
    cx: 18.2951981,
    cy: 18.2951981,
    r: 19.1951981
  }), /*#__PURE__*/React.createElement("g", {
    id: "illustraton/bot",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "antennae",
    transform: "translate(14.434999, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29743211,6.10869731 C5.57727688,5.80325933 3.81866667,5.49886666 1.02160148,5.19551928 L-0.860739966,7.01420153",
    id: "Path-Copy",
    stroke: "#000000",
    strokeWidth: 0.734999975,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2.718346, 6.104860) rotate(-59.000000) translate(-2.718346, -6.104860) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    fill: "#000000",
    cx: 4.67499987,
    cy: 2.97818172,
    rx: 2.9399999,
    ry: 2.97818172
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    fill: "#EF6461",
    cx: 4.67499987,
    cy: 2.97818172,
    rx: 1.46999995,
    ry: 1.48909086
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5186359,9.67909058 L16.3513631,9.67909058 C24.3697843,9.67909058 30.8699989,16.1793053 30.8699989,24.1977264 L30.8699989,34.3063625 C30.8699989,36.7419381 28.8955748,38.7163623 26.4599991,38.7163623 L4.40999985,38.7163623 C1.97442419,38.7163623 2.98271994e-16,36.7419381 0,34.3063625 L0,24.1977264 C-9.81973383e-16,16.1793053 6.50021469,9.67909058 14.5186359,9.67909058 Z",
    id: "Rectangle",
    fill: "#EF6461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9886358,9.67909058 C7.97021464,9.67909058 1.46999995,16.1793053 1.46999995,24.1977264 L1.46999995,24.1977264 L1.46999995,34.3063625 C1.46999995,36.7419381 3.44442414,38.7163623 5.8799998,38.7163623 L5.8799998,38.7163623 L4.40999985,38.7163623 C1.97442419,38.7163623 -2.05916837e-14,36.7419381 -2.08899557e-14,34.3063625 L-2.08899557e-14,24.1977264 C-2.18719291e-14,16.1793053 6.50021469,9.67909058 14.5186359,9.67909058 Z",
    id: "Combined-Shape",
    fill: "#943E3C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(9.555000, 14.890909)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.734999975,
    fill: "#FFFFFF",
    cx: 7.34999975,
    cy: 11.9127269,
    rx: 6.98249976,
    ry: 7.0779543
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8608511,1.79954696 C11.1216636,0.888665858 9.13509789,0.372272715 7.02550368,0.372272715 C4.8279776,0.372272715 2.76394993,0.93261151 0.973976796,1.91549599",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2.20499992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#000000",
    cx: 7.34999975,
    cy: 11.9127269,
    rx: 3.67499987,
    ry: 3.72272715
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    fill: "#FFFFFF",
    cx: 9.55499967,
    cy: 9.67909058,
    rx: 1.46999995,
    ry: 1.48909086
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 11.649351) rotate(-34.000000) translate(-9.000000, -11.649351) translate(0.500000, 8.103896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 16.5,
    height: 6.59090909
  }), /*#__PURE__*/React.createElement("text", {
    id: "WIP",
    fontFamily: "PublicoHeadline-Bold, Publico Headline",
    fontSize: 5,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.5,
    y: 5.55194805
  }, "WIP"))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotSelect);
export default __webpack_public_path__ + "static/media/bot_select.a60cf885cd5121c0cc5ff196bddc9fb1.svg";
export { ForwardRef as ReactComponent };